//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debug from 'debug'
import SquareCanSvg from '@/assets/svg/square-can.svg?inline'
import waypointMixin from '@/mixins/waypoint'

const log = debug('HomeProducts')

export default {
  name: 'HomeProducts',
  components: { SquareCanSvg },
  mixins: [waypointMixin],
  mounted() {
    log('Mounted')
  },
}
